export const heroImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/0ea6fe08-addf-4d14-84d8-3b58e5546e64.jpg'

export const jointIllustration =
  'https://cdn.magicpatterns.com/patterns/generated-images/7c07c911-933b-4aaf-91a4-0f944348dff6.jpg'

export const productImage =
  'https://cdn.magicpatterns.com/uploads/12U2FdPtF2vFPdHg2foFmP/Captura_de_pantalla_2026-08-16_a_las_6.20.00_p.m..png'

export const lifestyleImage =
  'https://cdn.magicpatterns.com/patterns/generated-images/a4496f79-043f-4481-86ae-902bce08ed57.jpg'

export const CTA_LABEL = 'SEE HOW JOINT GENESIS WORKS →'

export const mobilityAreas = [
  {
    id: 'knees',
    area: 'Knees',
    description: 'Stiffness when walking or climbing stairs',
  },
  {
    id: 'hips',
    area: 'Hips',
    description: 'Discomfort during movement or standing up',
  },
  {
    id: 'hands',
    area: 'Hands',
    description: 'Less comfort when gripping or using your hands',
  },
  {
    id: 'mobility',
    area: 'Mobility',
    description: 'Feeling less free in everyday activities',
  },
] as const

export const formulaPoints = [
  'Supports natural joint lubrication',
  'Helps promote smoother movement',
  'Designed for everyday joint wellness',
  'Easy to add to your daily routine',
] as const

export const lifestyleBenefits = [
  {
    id: 'comfort',
    title: 'Move with greater comfort',
    description: 'Getting up, walking and turning without thinking twice.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/76d62f02-2eff-4100-b943-89e98a380daa.jpg',
    imageAlt:
      'A woman in her fifties walking comfortably along a sunlit forest trail',
  },
  {
    id: 'confidence',
    title: 'Feel more confident walking',
    description: 'Longer outings and steadier steps.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/ff1bedd6-3b50-466f-b8c0-ded91305de39.jpg',
    imageAlt:
      'A couple in their sixties walking hand in hand along a boardwalk by the ocean',
  },
  {
    id: 'freedom',
    title: 'Enjoy more freedom in daily activities',
    description: 'Cooking, tending the garden, playing with the grandkids.',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/f5d8fc45-f199-4c15-b1e0-8243e9d990ce.jpg',
    imageAlt:
      'Close-up of an older adult kneading bread dough on a wooden kitchen counter',
  },
] as const

export const testimonials = [
  {
    id: 'perspective',
    quote:
      'I thought it was just part of getting older, but learning about joint lubrication changed the way I saw it.',
    name: 'Karen R.',
    age: '58',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/b47a21e3-9f4e-42f3-a837-c46ec79e46b0.jpg',
  },
  {
    id: 'understanding',
    quote:
      'What caught my attention was finally understanding what may really be going on inside the joints.',
    name: 'Robert L.',
    age: '61',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/dbe3f2f6-5ca6-40a2-96fd-8ae376ac16f2.jpg',
  },
  {
    id: 'clarity',
    quote:
      'The presentation made the concept easy to understand and gave me a new perspective.',
    name: 'Diane V.',
    age: '52',
    image:
      'https://cdn.magicpatterns.com/patterns/generated-images/67eb419d-da87-413d-9e6d-0a2f0cbbd6f6.jpg',
  },
] as const
